<template>
  <div>
    <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false"
           width="1400">
<!--      <Card :bordered="false" :style="{marginBottom:'10px'}">-->
<!--        <div class="hs-screen-row">-->
<!--          <Input v-model="params.nickName" placeholder="昵称" clearable style="width: 200px"/>-->
<!--        </div>-->
<!--        <div class="hs-screen-row">-->
<!--          <Button type="primary" @click="findList">查询</Button>-->
<!--        </div>-->
<!--        <div class="hs-screen-row">-->
<!--          <Button @click="resetScreen">重置</Button>-->
<!--        </div>-->
<!--      </Card>-->
      <Card :bordered="false" :style="{marginBottom:'10px'}">
        <!--表格数据-->
        <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading"
            >

          <template slot-scope="{ row, index }" slot="orderState">
            <span v-if="row.orderState == 1"><Tag color="success">未接单</Tag></span>
            <span v-if="row.orderState == 2"><Tag color="warning">已接单</Tag></span>
            <span v-if="row.orderState == 3"><Tag color="default">已完成</Tag></span>
            <span v-if="row.orderState == 4"><Tag color="default">已取消</Tag></span>
          </template>

          <template slot-scope="{ row, index }" slot="orderType">
            <span v-if="row.orderType == 1"><Tag color="success">线上订单</Tag></span>
            <span v-if="row.orderType == 2"><Tag color="warning">线下订单</Tag></span>
          </template>

          <template slot-scope="{ row, index }" slot="payType">
            <span v-if="row.payType == 1"><Tag color="success">线上支付</Tag></span>
            <span v-if="row.payType == 2"><Tag color="warning">线下支付</Tag></span>
          </template>

          <template slot-scope="{ row, index }" slot="isDeduct">
            <span v-if="row.isDeduct == 0"><Tag color="success">否</Tag></span>
            <span v-if="row.isDeduct == 1"><Tag color="warning">是</Tag></span>
          </template>

          <template slot-scope="{ row, index }" slot="isAbnormal">
            <span v-if="row.isAbnormal == 0"><Tag color="success">正常</Tag></span>
            <span v-if="row.isAbnormal == 1"><Tag color="error">异常</Tag></span>
          </template>

          <template slot-scope="{ row, index }" slot="recoveryTime">

                  <span v-if="row.recoveryTime">
                    <span v-if="row.recoveryTimeStatus && row.recoveryTimeStatus === 0">
                      {{row.recoveryTime}}
                    </span>
                    <span style="color: #FF8C00" v-else-if="row.recoveryTimeStatus && row.recoveryTimeStatus === 1">
                      {{row.recoveryTime}}
                    </span>
                    <span style="color: red" v-else-if="row.recoveryTimeStatus && row.recoveryTimeStatus === 2">
                      {{row.recoveryTime}}
                    </span>
                    <span v-else>
                      {{row.recoveryTime}}
                    </span>
                  </span>
            <span v-else>-</span>
          </template>

          <template slot-scope="{ row, index }" slot="totalAmount">
            <span v-if="row.totalAmount">{{row.totalAmount}}</span>
            <span v-else>-</span>
          </template>

          <template slot-scope="{ row, index }" slot="realName">
            <span v-if="row.realName">{{row.realName}}</span>
            <span v-else>{{row.nickName}}</span>
            <span v-if="row.isVip == 1"><Tag color="warning"> VIP </Tag></span>
          </template>

          <template slot-scope="{ row, index }" slot="integral">
            <span v-if="row.integral">{{row.integral}}</span>
            <span v-else>-</span>
          </template>


<!--          <template slot-scope="{ row }" slot="action">-->
<!--            <Button type="success" size="small" style="margin-right: 5px" @click="showOrderOpe(row)">查看-->
<!--            </Button>-->
<!--            <Dropdown transfer trigger="click">-->
<!--              <Button size="small">-->
<!--                <Icon type="ios-more" size="22"/>-->
<!--              </Button>-->
<!--              <DropdownMenu slot="list">-->
<!--                <DropdownItem @click.native="isOrderCancel(row)" v-if="row.orderState < 3">取消订单-->
<!--                </DropdownItem>-->
<!--                <DropdownItem @click.native="isDeleteOrderMall(row)" v-if="row.orderState > 2">删除-->
<!--                </DropdownItem>-->
<!--                <DropdownItem @click.native="isAbnormalOrder(row)" v-if="row.isAbnormal == 1">处理异常-->
<!--                </DropdownItem>-->
<!--                <DropdownItem @click.native="showOrderDispatch(row)" v-if="row.orderState < 3">派单-->
<!--                </DropdownItem>-->
<!--                <DropdownItem @click.native="showOrderUpdate(row)" v-if="row.orderState === 3">修改订单-->
<!--                </DropdownItem>-->
<!--              </DropdownMenu>-->
<!--            </Dropdown>-->
<!--          </template>-->
        </Table>
        <!--分页-->
        <div class="hs-page">
          <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                @on-page-size-change="changePageSize"/>
        </div>
      </Card>

      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
        <Button @click="hide('formValidate')">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      title: '回收订单列表',
      total: 0,
      params: {
        page: 1,
        rows: 10,
        recoveryUserId: '',
        startUpdateTime: '',
        endUpdateTime: '',
        orderState: 3
      },
      isTableLoading: false,
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: 'ID',
          minWidth: 130,
          key: 'recoveryOrderId'
        },
        // {
        //     title: '订单编号',
        //     minWidth: 190,
        //     key: 'orderCode'
        // },
        {
          title: '订单标题',
          minWidth: 90,
          key: 'orderTitle',
          ellipsis: true
        },
        {
          title: '订单状态',
          slot: 'orderState',
          align: 'center',
          width: 120
        },
        {
          title: '订单类型',
          slot: 'orderType',
          align: 'center',
          width: 120
        },
        {
          title: '支付类型',
          slot: 'payType',
          align: 'center',
          width: 120
        },
        {
          title: '是否扣杂',
          slot: 'isDeduct',
          align: 'center',
          width: 100
        },
        {
          title: '异常状态',
          slot: 'isAbnormal',
          align: 'center',
          width: 120
        },
        {
          title: '预约时间',
          slot: 'recoveryTime',
          align: 'center',
          width: 150
        },
        {
          title: '回收金额（元）',
          minWidth: 120,
          slot: 'totalAmount'
        },
        {
          title: '赠送积分',
          minWidth: 120,
          slot: 'integral'
        },
        {
          title: '用户名',
          minWidth: 180,
          slot: 'realName'
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 150
        },
      ],
      // 表格数据
      data: [],
      userIds: []
    }
  },
  methods: {
    // 显示模态框
    show(row) {
      this.isShowModal = true;
      this.userIds = []
      this.params.startUpdateTime = row.startTime
      this.params.endUpdateTime = row.endTime
      this.params.recoveryUserId = row.recoveryUserId
      this.findList();
    },
    // 查询订单列表
    findList(row) {
      this.$Spin.show();
      this.axios.post('/recoveryOrder/findList', this.params).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询回收列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 重置筛选条件
    resetScreen() {
      this.params.nickName = '';
      this.params.page = 1
      this.params.rows = 10
      this.findList();
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      // this.$refs[name].resetFields();
    },
    save() {
      if (this.userIds.length === 0) {
        this.$Notice.error({
          title: '添加失败',
          desc: '请先选择参与活动的用户！'
        });
        return ;
      }
      this.axios.post('/activityUser/saveActivityUser', {userArr: this.userIds}).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        this.isTableLoading = false;
        if (res.status == 201) {
          this.$Notice.error({
            title: '添加失败',
            desc: res.msg
          });
        }
        if (res.status == 200) {
          this.$emit('changeDate');
          this.userIds = []
          this.$Message.success('添加成功.');
          this.hide('formValidate');
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询用户列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
    handleSelectRow(index) {
      let ids=[];
      this.$refs['selection2'].getSelection().map(item=>{
        ids.push(item.userId)
      })
      this.userIds=ids
      console.log('ids', ids)
    },
    onSelect() {
      console.log()
    }
  },
}
</script>

<style scoped>
</style>
